type Company = {
	name: string;
	id: string;
};

enum CompanyActionTypes {
	USER_GET_COMPANIES_REQUEST = 'USER_GET_COMPANIES_REQUEST',
	USER_GET_COMPANIES_SUCCESS = 'USER_GET_COMPANIES_SUCCESS',
	USER_GET_COMPANIES_FAILURE = 'USER_GET_COMPANIES_FAILURE',
	SEARCH_HUBSPOT_COMPANY_REQUEST = 'SEARCH_HUBSPOT_COMPANY_REQUEST',
	SEARCH_HUBSPOT_COMPANY_SUCCESS = 'SEARCH_HUBSPOT_COMPANY_SUCCESS',
	SEARCH_HUBSPOT_COMPANY_FAILURE = 'SEARCH_HUBSPOT_COMPANY_FAILURE',
	UPDATE_COMPANY_HS_ID_REQUEST = 'UPDATE_COMPANY_HS_ID_REQUEST',
	UPDATE_COMPANY_HS_ID_SUCCESS = 'UPDATE_COMPANY_HS_ID_SUCCESS',
	UPDATE_COMPANY_HS_ID_FAILURE = 'UPDATE_COMPANY_HS_ID_FAILURE',
	GET_COMPANY_HS_ID_REQUEST = 'GET_COMPANY_HS_ID_REQUEST',
	GET_COMPANY_HS_ID_SUCCESS = 'GET_COMPANY_HS_ID_SUCCESS',
	GET_COMPANY_HS_ID_FAILURE = 'GET_COMPANY_HS_ID_FAILURE',
	CREATE_COMPANY_REQUEST = 'CREATE_COMPANY_REQUEST',
	CREATE_COMPANY_SUCCESS = 'CREATE_COMPANY_SUCCESS',
	CREATE_COMPANY_FAILURE = 'CREATE_COMPANY_FAILURE',
	UPDATE_COMPANY_REQUEST = 'UPDATE_COMPANY_REQUEST',
	UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS',
	UPDATE_COMPANY_FAILURE = 'UPDATE_COMPANY_FAILURE',
	CLEAR_COMPANY_ERRORS = 'CLEAR_COMPANY_ERRORS'
}

type CompanyError = Error | string;

interface CompanyAction {
	type: CompanyActionTypes;
	payload?: any;
	error?: CompanyError;
}

export { Company, CompanyActionTypes, CompanyAction };
